import React from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../../../store/app'
import { addNetworkProvider } from '../../../../store/NetworkProviderSlice'
import FormNetworkProvider from './FormNetworkProvider'
import { Form } from 'antd'

const AddNetworkProvider: React.FC<any> = ({
    getList,
    totalData
}) => {
    const dispatch: AppDispatch = useDispatch()
    const [form] = Form.useForm();
    const handleAddSubmit = (data: any) => {
        dispatch(addNetworkProvider(data))
            .then(() => {
                getList();
            })
            .catch((e: any) => {
                console.warn(e)
            })
    }
    return (
        <FormNetworkProvider
            form={form}
            handleAddSubmit={handleAddSubmit}
            mode={'add'}
            totalData={totalData}
        />
    )
}

export default AddNetworkProvider